'use client'

/* eslint-disable @next/next/no-img-element */

/* eslint-disable jsx-a11y/alt-text */
import { cn } from 'shared/libs/style-merge'

import { useEffect, useRef, useState } from 'react'

import './style.css'

interface Props {
  withBlur?: boolean
  src?: string
  quality?: number
  className?: string
  width?: number
  height?: number
  alt?: string
  style?: React.CSSProperties
  fetchPriority?: 'high' | 'low' | 'auto'
}

export function Image({
  src,
  withBlur,
  className = '',
  fetchPriority = 'auto',
  ...props
}: Props) {
  const [imageError, setImageError] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)
  const imageRef = useRef<HTMLImageElement>(null)

  useEffect(() => {
    const handleLoad = () => {
      if (imageRef.current) {
        imageRef.current.classList.add('loaded')
        setIsLoaded(true)
      }
    }

    const img = imageRef.current
    if (img?.complete) {
      handleLoad()
    } else {
      img?.addEventListener('load', handleLoad)
    }

    return () => img?.removeEventListener('load', handleLoad)
  }, [])
  return (
    <>
      {withBlur && !isLoaded && (
        <div
          style={{
            width: `${props.width}px`,
            height: `${props.height}px`,
            position: 'absolute',
          }}
          className={cn('skeleton', className)}
        />
      )}
      <img
        ref={imageRef}
        onError={() => setImageError(true)}
        src={imageError || !src ? '/static/empty.png' : src}
        className={cn('image', className)}
        {...props}
        alt={props.alt}
        fetchPriority={fetchPriority}
      />
    </>
  )
}
